import { TypeAttendance } from "../../backend-definitions.module";

export class ExameType {
    id:number;
	code:string;
	typeAttendance:TypeAttendance;
	name:string;
	active:boolean;
}
